"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGeoCountry = void 0;
var react_1 = require("react");
var countries_1 = require("../countries");
var geo_1 = require("../geo");
var useGeoCountry = function () {
    var _a;
    var data = (0, geo_1.useGeo)().data;
    var countries = (0, countries_1.useCountriesOptions)();
    var geoCountry = (0, react_1.useMemo)(function () {
        return countries.find(function (country) { var _a; return country.value === ((_a = data === null || data === void 0 ? void 0 : data.geoData) === null || _a === void 0 ? void 0 : _a.countryCode); });
    }, [countries, (_a = data === null || data === void 0 ? void 0 : data.geoData) === null || _a === void 0 ? void 0 : _a.countryCode]);
    return (0, react_1.useMemo)(function () { return geoCountry === null || geoCountry === void 0 ? void 0 : geoCountry.value; }, [geoCountry]);
};
exports.useGeoCountry = useGeoCountry;
